import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import { App } from './app/app'

import { datadogLogs } from '@datadog/browser-logs'
import { environment } from './environments/environment'

if (environment.production || environment.datadog.force) {
  datadogLogs.init({
    clientToken: environment.datadog.clientToken,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    service: 'Kistill Web',
    env: environment.datadog.env,
  })
}

const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
  },
])

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
